import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'
import { indexedPublicationsAToC } from 'about/ui/indexedPublications/indexedPublicationsAToC'
import { indexedPublicationsDToF } from 'about/ui/indexedPublications/indexedPublicationsDToF'
import { indexedPublicationsGToJ } from 'about/ui/indexedPublications/indexedPublicationsGToJ'
import { indexedPublicationsKToL } from 'about/ui/indexedPublications/indexedPublicationsKToL'
import { indexedPublicationsMToP } from 'about/ui/indexedPublications/indexedPublicationsMToP'
import { indexedPublicationsRToV } from 'about/ui/indexedPublications/indexedPublicationsRToV'
import { indexedPublicationsWToZ } from 'about/ui/indexedPublications/indexedPublicationsWToZ'

export const indexedPublications: readonly IndexedPublicationsSection[] = [
  ...indexedPublicationsAToC,
  ...indexedPublicationsDToF,
  ...indexedPublicationsGToJ,
  ...indexedPublicationsKToL,
  ...indexedPublicationsMToP,
  ...indexedPublicationsRToV,
  ...indexedPublicationsWToZ,
]
